import styled from 'styled-components';
export const BookNowPayLaterHoverWrapper = styled.div(
  props => `
  display: inline-block;
  position: relative;
  right:4px;
  `,
);
export const BookNowPayLaterOuterWrap = styled.div(
  props => `
    display:flex;
    justify-content: space-between;
    padding:${props.theme.spacing.base};
    position:relative;
    z-index:9999;
    `,
);

export const BookNowPayLaterHoverOuterWrap = styled.div(
  props => `
    background:${props.theme.colors.goTeal.light};
    padding:${props.theme.spacing.custom(16)};
    border-radius: ${props.theme.misc.borderRadius.base};
    border: .15rem solid ${props.theme.colors.goTeal.medium};
    width: 36.5rem;
    position:absolute;
    ${props.customDisplay ? `display: ${props.customDisplay};` : `display: block;`}
    z-index: 2 ;
    // z-index: 1;
    // z-index:${props.theme.misc.zIndex.xsmall};
  `,
);

export const BookNowPayLaterHoverHeaderWrap = styled.div(
  props => `
    display : flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom:${props.theme.spacing.xlarge};
  `,
);

export const BookNowPayLaterHoverInnerHeaderWrap = styled.div(
  props => `
      display : flex;
      align-items:center;
      margin-top: 1rem;
      background: ${props.theme.colors.goWhite.base};
      padding:0 ${props.theme.spacing.small};
      border-radius: ${props.theme.misc.borderRadius.custom(12.5)};
      width: fit-content;
      height:2.5rem;
  `,
);

export const BookNowPayLaterHoverText = styled.p(
  props => `
    font-weight: 600;
    padding: 0 ${props.theme.spacing.small} 0;
  `,
);

export const BookNowPayLaterStepsOuterWrap = styled.div(
  props => `
    position:relative;
    `,
);

export const StepIndicatorWrap = styled.div(
  props => `
    padding-bottom: ${props.theme.spacing.xlarge};
    padding-left:${props.theme.spacing.custom(18)};
    border-left: .3rem solid ${props.theme.colors.goTeal.dark};
    margin-left: 1.05rem;
    position: relative;
    box-sizing: border-box;
    &:last-child {
      padding-bottom: ${props.theme.spacing.base};
      border-color: transparent;
    }
    &:nth-last-child(2){
      border-color: ${props.theme.colors.goBrandOrange.dark};
    }
    `,
);

export const BookNowPayLaterIconWrap = styled.div(
  props => `
  display: flex;
  align-items: center;
  justify-content: center;
    left: -1.35rem;
    position:absolute;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    background: ${props.theme.colors.goTeal.dark};
    border: .1rem solid ${props.theme.colors.goTeal.base};
    `,
);

export const HotelIconWrap = styled.div(
  props => `
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    left: -1.35rem;
    width: 2.4rem;
    height: 2.4rem;
    border-radius: 50%;
    background: ${props.theme.colors.goBrandOrange.dark};
    border: .1rem solid ${props.theme.colors.goBrandOrange.dark};
    `,
);

export const HorizontalStepMarker = styled.div(
  props =>
    `
    position: absolute;
    border-top: .4rem solid ${props.theme.colors.goTeal.dark};
    width: .9rem;
    left: 0.3rem;
    top: 0.5rem;
    border-radius: ${props.theme.misc.borderRadius.large};
}
  `,
);

export const CircularLineIndicator = styled.div(
  props => `
    width: 1.3rem;
    height: 1.3rem;
    border-radius:50%;
    border:.3rem solid ${props.theme.colors.goTeal.dark};
    background: ${props.theme.colors.goWhite.base};
    position:absolute;
    left: -0.8rem;
    top: 0;
    padding: 0.2rem 0;
    &::after{
      content: "";
      position: absolute;
      border-top: .4rem solid ${props.theme.colors.goTeal.dark};
      top: 0.2rem;
      width: .9rem;
      left:.9rem;
      border-radius: ${props.theme.misc.borderRadius.large};
    }
    `,
);

export const BookNowPayLaterText = styled.p(
  props => `
    padding: 0 ${props.theme.spacing.small} 0;
  `,
);

export const BookNowPayLaterStepsHeader = styled.span(
  props => `
    font-size:${props.theme.font.custom(14)};
    font-weight: 600;
    color: ${props.customColor || props.theme.colors.downriver.base}
    `,
);

export const BookTodayChargesCondition = styled.p(
  props => `
    font-size:${props.theme.font.custom(11)};
    color: ${props.customColor || props.theme.colors.goTeal.dark};

    `,
);

export const BookTodayCondition = styled.p(
  props => `
    font-size:${props.theme.font.custom(11)};
    color: ${props.customColor || props.theme.colors.downriver.medium};
    `,
);

export const BookTodayRefundCondition = styled.p(
  props => `
    font-size:${props.theme.font.custom(11)};
    color:${props.theme.colors.goBrandOrange.dark};
    `,
);

export const BookNowPayLaterWrap = styled.div(
  props => `
      display : flex;
      align-items:center;
      justify-content: flex-end;
      margin-top: 1rem;
      background: ${props.theme.colors.goTeal.light};
      padding:0 ${props.theme.spacing.xsmall};
      border-radius: ${props.theme.misc.borderRadius.base};
      width: fit-content;
      height:2.4rem;

      &:hover > ${BookNowPayLaterHoverOuterWrap} {
        visibility: visible;
      }
  `,
);

export const TipUI = styled.div`
  position: absolute;
  width: 2.4rem;
  height: 2.4rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.3rem;
    left: 50%;
    background: ${props => props.theme.colors.goTeal.light};
    z-index: ${props => props.theme.misc.zIndex.large};
  }
`;
export const TipPositioning = styled(TipUI)`
  top: 50%;
  left: 0;
  transform: translate(-50%, -50%);
  box-sizing: border-box;
  &::after {
    transform: translate(-50%, 50%) rotate(-45deg);
    background: ${props => props.bgColor};
    border-top: 0.15rem solid ${props => props.theme.colors.goTeal.medium};
    border-left: 0.15rem solid ${props => props.theme.colors.goTeal.medium};
  }
`;
